enum TableFieldPattern {
  INTENGERS_ONLY = '^[0-9\b]+$',
  DECIMAL_ONLY = '^[0-9]+(\.[0-9]+)?$',
}

export default TableFieldPattern;
